import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Navbar from "./Navbar";
import HeroSection from "./HeroSection";
import Services from "./Services";
import Contact from "./Contact";
import Footer from "./Footer";
import InstaFeeds from "./InstaFeeds";
import MyApproach  from "./MyApproach";
import Testimonials from "./Testimonials";

const Home = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const lang = params.get("lang");

    if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang).then(() => setReady(true));
    } else {
      setReady(true);
    }
  }, [location, i18n]);

  if (!ready) return null; // or a loader/spinner

  return (
    <div className="home-container">
      <Navbar />
      <HeroSection />
      <section id="testimonials">
        <Testimonials />
      </section>
      <section id="my-approach">
        <MyApproach />
      </section>
      <section id="services">
        <Services />
      </section>
      <section id="contact">
        <Contact />
      </section>
      <InstaFeeds token={process.env.REACT_APP_INS_TOKEN} limit={3} />
      <Footer />
    </div>
  );
};

export default Home;
